import { configureStore } from '@reduxjs/toolkit';
import rfpTemplateReducer from './slices/rfpTemplateSlice';
import rfpBuilderReducer from './slices/rfpBuilderSlice';
import rfpCollaborationReducer from './slices/rfpCollaborationSlice';
import { templateApi } from './api/templateApi';

export const store = configureStore({
  reducer: {
    rfpTemplate: rfpTemplateReducer,
    rfpBuilder: rfpBuilderReducer,
    rfpCollaboration: rfpCollaborationReducer,
    [templateApi.reducerPath]: templateApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore Socket.IO instances and React elements in actions
        ignoredActions: [
          'rfpCollaboration/setSocket',
          'rfpBuilder/selectElement',
          'rfpBuilder/setDraggedItem',
        ],
        ignoredPaths: [
          'rfpCollaboration.socket',
          'rfpBuilder.selectedElement.data',
          'rfpBuilder.draggedItem',
        ],
      },
    }).concat(templateApi.middleware),
});

export default store;
